import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'util/Constants';
import HelloDataMark from '../HelloDataMark';
import { WhatsApp as WhatsAppIcon } from '@mui/icons-material';

const FeedbackButton = () => {
    const handleFeedbackClick = () => {
        window.open(
            'https://api.whatsapp.com/send?phone=34603400632&text=Hey%2C%20I%20would%20like%20to%20share%20some%20feedback%20for%20hello%3Adata',
            '_blank',
        );
    };

    return (
        <button
            onClick={handleFeedbackClick}
            className="flex items-center gap-2 px-3 py-2 rounded-full hover:bg-gray-100 transition-colors border border-gray-200"
            title="Share Feedback"
        >
            <WhatsAppIcon style={{ color: '#25D366' }} />
            <span className="hidden [@media(min-width:900px)]:inline text-[14px]">Feedback</span>
        </button>
    );
};

const JoinNowButton = () => {
    const navigate = useNavigate();

    const handleJoinClick = () => {
        navigate(ROUTES.SIGN_UP);
    };

    return (
        <button
            onClick={handleJoinClick}
            className="bg-my-blue hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors text-sm whitespace-nowrap"
        >
            Join now
        </button>
    );
};

const ClickableHelloDataMark = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(ROUTES.LADNING);
    };

    return (
        <div onClick={handleClick} className="cursor-pointer">
            <HelloDataMark />
        </div>
    );
};

const PublicHeader = () => {
    const navigate = useNavigate();

    return (
        <div className="border-b border-my-gray border-opacity-60 bg-white lg:px-0 px-[20px]">
            {/* Desktop Header - shows logo only on large screens (1280px+) */}
            <div className="hidden lg:block">
                <div className="h-[72px] lg:max-w-hello mx-auto flex items-center">
                    <div className="w-[200px]">
                        <ClickableHelloDataMark />
                    </div>
                    <div className="flex-1"></div>
                    <div className="w-[200px] flex justify-end items-center gap-[12px]">
                        <FeedbackButton />
                        <JoinNowButton />
                    </div>
                </div>
            </div>

            {/* Tablet Header - shows logo on left (744px - 1279px) */}
            <div className="hidden md:block lg:hidden">
                <div className="h-[72px] lg:max-w-hello mx-auto flex items-center">
                    <div className="w-[200px]">
                        <ClickableHelloDataMark />
                    </div>
                    <div className="flex-1"></div>
                    <div className="flex justify-end items-center gap-[12px]">
                        <FeedbackButton />
                        <JoinNowButton />
                    </div>
                </div>
            </div>

            {/* Mobile Header - shows logo on left (below 744px) */}
            <div className="block md:hidden">
                <div className="flex px-4 py-3 h-fit items-center">
                    <div className="w-[120px]">
                        <ClickableHelloDataMark />
                    </div>
                    <div className="flex-1"></div>
                    <div className="flex justify-end items-center gap-[8px]">
                        <FeedbackButton />
                        <JoinNowButton />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PublicHeader;
